export default __webpack_public_path__ + "9346d2b81cdb82b7cf964d834253a836.png";